export default __webpack_public_path__ + "static/media/stereo_dark.1b6dfafc.png";